import { Navigate, Route, Routes } from 'react-router-dom';

import Home from '../../components/layout/treatment-plan/Home';
import ClientProviderInfo from '../../components/layout/treatment-plan/ClientInfo';
import Background from '../../components/layout/treatment-plan/background';
import CrisisPlan from '../../components/layout/treatment-plan/crisis-plan/CrisisPlan';
import Goals from '../../components/layout/treatment-plan/goals';
import InitialAssessment from '../../components/layout/treatment-plan/initialAssessment';
import MedicalAndReferralHistory from '../../components/layout/treatment-plan/medical-history';
import Medications from '../../components/layout/treatment-plan/medications';
import TransitionDischarge from '../../components/layout/treatment-plan/discharge-transition';
import TherapyHistory from '../../components/layout/treatment-plan/therapy-history';
import TreatmentRecommendations from '../../components/layout/treatment-plan/treatmentRecommendations';

export default function TreatmentPlanLegacyRoutes() {
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="client-info" element={<ClientProviderInfo />} />
      <Route path="med-info" element={<MedicalAndReferralHistory />} />
      <Route path="medications" element={<Medications />} />
      <Route path="history" element={<TherapyHistory />} />
      <Route path="background" element={<Background />} />
      <Route path="assessment" element={<InitialAssessment />} />
      <Route path="crisis-plan" element={<CrisisPlan />} />
      <Route path="goals" element={<Goals />} />
      <Route path="discharge-transition" element={<TransitionDischarge />} />
      <Route path="treatment-recommendation" element={<TreatmentRecommendations />} />
      {/* Switching from a v3 plan carries its tab name over, which has no legacy page. */}
      <Route path="*" element={<Navigate replace to="client-info" />} />
    </Routes>
  );
}
